import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import DealerForm from "../../components/DealerForm";
import { compose, withHandlers } from "recompose";
import WithFetchDealer from "../WithFetchDealer/index";
import { withRouter } from "react-router-dom";

const UpdateDealer = ({
  submittingDealer,
  failSubmitDealer,
  onSubmit,
  currentDealer
}) => {
  return (
    <div className="content">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h3>Update Dealer</h3>
          <DealerForm
            initialValues={currentDealer}
            submittingDealer={submittingDealer}
            failSubmitDealer={failSubmitDealer}
            onSubmit={onSubmit}
          />
        </Col>
      </Row>
    </div>
  );
};

UpdateDealer.propTypes = {
  submittingDealer: PropTypes.bool.isRequired,
  failSubmitDealer: PropTypes.string,
  createDealer: PropTypes.func.isRequired
};

const withSubmit = withHandlers({
  onSubmit: ({ updateDealer, history }) => data => {
    updateDealer(data).then(resolvedDealer => {
      history.push("/dealers");
    });
  }
});

export default compose(
  WithFetchDealer,
  withRouter,
  withSubmit
)(UpdateDealer);
